export default "__VITE_ASSET__k8Jagb1D__"